<template>
  <div>
    <el-popover
      :disabled="isCodeViewMode"
      placement="bottom"
      trigger="click"
      popper-class="el-tiptap-popper"
    >
      <div class="el-tiptap-popper__menu">
        <div class="el-tiptap-popper__menu__item" @click="openUrlPrompt">
          <span>외부 이미지 URL</span>
        </div>
        <div class="el-tiptap-popper__menu__item" @click="imageUploadDialogVisible = true">
          <span>이미지 업로드</span>
        </div>
      </div>
      <el-tooltip
        slot="reference"
        content="이미지"
        :open-delay="350"
        :disabled="isCodeViewMode"
        transition="el-zoom-in-bottom"
        effect="dark"
        placement="top"
      >
        <div
          :class="{
            'el-tiptap-editor__command-button': true,
            'el-tiptap-editor__command-button--readonly': isCodeViewMode,
          }"
          @mousedown.prevent
        >
          <i class="el-icon-picture-outline" style="font-size: 16px;"></i>
        </div>
      </el-tooltip>
    </el-popover>

    <el-dialog
      title="이미지 업로드"
      :visible.sync="imageUploadDialogVisible"
      append-to-body
    >
      <el-upload
        class="el-tiptap-upload"
        :http-request="uploadImage"
        :show-file-list="false"
        action="#"
        drag
        accept="image/*"
        multiple
      >
        <div class="el-tiptap-upload__icon">
          <i class="el-icon-upload" style="font-size: 40px;"></i>
        </div>
        <div class="el-tiptap-upload__text">
          이미지 파일을 여기에 끌어넣거나 클릭하여 선택하세요 (여러 장 가능)
        </div>
      </el-upload>
    </el-dialog>
  </div>
</template>

<script>
import { MessageBox, Popover, Dialog, Upload, Tooltip } from 'element-ui';

export default {
  name: 'MultiImageUploadButton',
  components: {
    'el-popover': Popover,
    'el-dialog': Dialog,
    'el-upload': Upload,
    'el-tooltip': Tooltip,
  },
  props: {
    editorContext: {
      type: Object,
      required: true,
    },
  },
  inject: {
    et: { default: null },
  },
  data() {
    return {
      imageUploadDialogVisible: false,
    };
  },
  computed: {
    isCodeViewMode() {
      return this.et ? this.et.isCodeViewMode : false;
    },
    imageNodeOptions() {
      return this.editorContext.editor.extensions.options.image;
    },
  },
  methods: {
    openUrlPrompt() {
      MessageBox.prompt('', '외부 이미지 URL 삽입', {
        confirmButtonText: '확인',
        cancelButtonText: '취소',
        inputPlaceholder: 'https://example.com/image.png',
        inputErrorMessage: '유효하지 않은 URL입니다.',
        roundButton: true,
      }).then(async ({ value }) => {
        const defaultWidth = this.imageNodeOptions.defaultWidth || 200;
        try {
          const img = await this.preloadImage(value);
          const width = defaultWidth;
          const height = Math.round(img.naturalHeight * (defaultWidth / img.naturalWidth));
          this.editorContext.commands.image({ src: value, width, height });
        } catch {
          this.editorContext.commands.image({ src: value });
        }
      }).catch(() => {});
    },
    preloadImage(src) {
      return new Promise((resolve, reject) => {
        const img = new window.Image();
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = src;
      });
    },
    async uploadImage({ file }) {
      const uploadRequest = this.imageNodeOptions.uploadRequest;
      if (!uploadRequest) {
        console.error('uploadRequest option is not provided for Image extension');
        return;
      }
      this.imageUploadDialogVisible = false;
      try {
        const url = await uploadRequest(file);
        if (url) {
          // 이미지를 미리 로드하여 원본 크기를 구한 뒤 삽입
          try {
            const img = await this.preloadImage(url);
            const defaultWidth = this.imageNodeOptions.defaultWidth || 200;
            const width = defaultWidth;
            const height = Math.round(img.naturalHeight * (defaultWidth / img.naturalWidth));
            this.editorContext.commands.image({ src: url, width, height });
          } catch (preloadErr) {
            // 프리로드 실패 시에도 삽입 (width 미지정 → 기본 200px)
            this.editorContext.commands.image({ src: url });
          }
        }
      } catch (e) {
        console.error('Image upload failed:', e);
      }
    },
  },
};
</script>
